import { IconButton } from "@mui/material";
import React from "react";

export default function CloseIconBtn({ color = "currentColor", onClick, disabled }) {
  return (
    <IconButton
      onClick={onClick}
      sx={{ background: "var(--light-grey)", p: "4px", width: "36px", height: "36px" }}
      disabled={disabled}
    >
      <svg
        width="12"
        height="12"
        viewBox="0 0 36 36"
        fill="none"
        style={{ color }}
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M20.0809 17.9982L30.6277 5.42629C30.8045 5.21736 30.6559 4.89995 30.3827 4.89995H27.1764C26.9876 4.89995 26.8068 4.98432 26.6822 5.12897L17.9836 15.4991L9.28489 5.12897C9.16436 4.98432 8.98355 4.89995 8.7907 4.89995H5.58445C5.31123 4.89995 5.16257 5.21736 5.33936 5.42629L15.8862 17.9982L5.33936 30.57C5.29975 30.6166 5.27435 30.6736 5.26615 30.7341C5.25796 30.7947 5.26732 30.8564 5.29312 30.9118C5.31893 30.9672 5.3601 31.0141 5.41173 31.0468C5.46337 31.0795 5.52332 31.0967 5.58445 31.0964H8.7907C8.97953 31.0964 9.16034 31.012 9.28489 30.8674L17.9836 20.4973L26.6822 30.8674C26.8027 31.012 26.9836 31.0964 27.1764 31.0964H30.3827C30.6559 31.0964 30.8045 30.779 30.6277 30.57L20.0809 17.9982Z"
          fill="black"
          fillOpacity="0.85"
        />
      </svg>
    </IconButton>
  );
}
